import React from 'react';
import { TParamLevelistOption } from '../../../api/endpoints/SubsetOption';
import { flatMap, range, isPlainObject } from 'lodash';
import { MatrixEditor } from '../../Ui/MatrixEditor';
import SelectAllControl from "../SelectAllControl";
import { TApiParameter } from "../../../api/endpoints/Parameter";
import ParameterLabel from "../../Ui/ParameterLabel";

type TParamLevelistOptionRange = {
  from: string;
  to: string;
}

const paramLevelistToOptions = (spec: TParamLevelistOption): Array<TParamLevelistValue> => {
  const { param, levelist } = spec.value;

  return flatMap(param, (param, index) => {
    let levels;

    if (typeof levelist[0] === 'string') {
      levels = levelist as Array<string>;
    } else {
      levels = levelist[index] as Array<string> | TParamLevelistOptionRange

      if (isPlainObject(levelist[index])) {
        const { from, to } = levelist[index] as TParamLevelistOptionRange

        levels = range(parseInt(from, 10), parseInt(to, 10) + 1).map(v => v.toString()) as Array<string>
      } else {
        levels = levelist[index] as Array<string>
      }
    }

    return levels.map(level => ({
      param,
      level
    }));
  });
};

export type TParamLevelistValue = {
  param: string,
  level: string
}

const columnLabel = (option: TParamLevelistValue) => option.param;
const rowLabel = (option: TParamLevelistValue) => option.level;

const ParamLevelistSelector = (props: {
  spec: TParamLevelistOption;
  values: Array<TParamLevelistValue>;
  params: { [shortname: string]: TApiParameter };
  onChange: (values: Array<TParamLevelistValue>) => void
}) => {
  const { spec, values, params, onChange } = props;
  const options = paramLevelistToOptions(spec);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <MatrixEditor
        options={options}
        selection={values}
        setSelection={onChange}
        optionToColumn={columnLabel}
        optionToRow={rowLabel}
        renderColumn={shortname => <ParameterLabel label={shortname} param={params[shortname.toLowerCase()]} />}
        needsFocus={false}
        acknowledgeFocusRequest={() => undefined}
        columnButtonContainsFocusableElement
      />
    </div>
  );
};

export default ParamLevelistSelector;
